import React from "react";
import { Modal, Button, Form } from "antd";
import TextInput from "../../ReusableInputs/TextInput";
import TextAreaInput from "../../ReusableInputs/TextAreaInput";
import { DataRecipe, Product } from "../../../@types/productInfo";
import { FaTimesCircle } from "react-icons/fa";
import { BsPlusCircle } from "react-icons/bs";
import SelectOption from "../../ReusableInputs/SelectOption";

interface RecipeModalProps {
  visible: boolean;
  isUpdating:boolean;
  onClose: () => void;
  isEditModal: boolean;

  productId: any;
  setProductId: (value: any) => void;

  products: Product[];

  handleSaveEdit: (recipeData: DataRecipe) => void;
  name: string;
  ingredients: string[];
  methods: string[];
  newMethod: string;
  newIngredient: string;
  setName: (value: string) => void;
  setIngredients: (value: string[]) => void;
  setMethods: (value: string[]) => void;
  setNewMethod: (value: string) => void;
  setNewIngredient: (value: string) => void;
  setImage: (value: string | null) => void;
  setDescription: (value: string) => void;
  setMetaDescription: (value: string) => void;
  setMetaTitle: (value: string) => void;
  setRecipeLink: (value: string) => void;
  image: string | null;
  description: string;
  meta_description: string;
  meta_title: string;
  recipelink: string;
  isProcessing: boolean;
  loading: boolean;
  isModalVisible: boolean;
  handleFormSubmit: () => void;
  handleFileChangeImage: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => Promise<void>;
  handleModalCancel: () => void;
}

const RecipeModal: React.FC<RecipeModalProps> = ({
  visible,
  onClose,
  isEditModal,
  handleSaveEdit,
  name,
  ingredients,
  methods,
  newMethod,
  newIngredient,
  setName,
  setIngredients,
  setMethods,
  setNewMethod,
  setNewIngredient,
  setImage,
  image,
  description,
  setDescription,
  meta_description,
  setMetaDescription,
  meta_title,
  setMetaTitle,
  recipelink,
  setRecipeLink,
  isProcessing,
  loading,
  isModalVisible,
  handleFormSubmit,
  handleFileChangeImage,
  handleModalCancel,
  products,
  productId,
  setProductId,
  isUpdating
}) => {
  const [form] = Form.useForm();

  const handleRemoveMethod = (index: number) => {
    const updatedMethods = [...methods];
    updatedMethods.splice(index, 1);
    setMethods(updatedMethods);
  };

  const handleRemoveIngredient = (index: number) => {
    const updatedIngredients = [...ingredients];
    updatedIngredients.splice(index, 1);
    setIngredients(updatedIngredients);
  };

  const handleAddMethod = () => {
    if (newMethod.trim() === "") return;
    const updatedMethods = [...methods, newMethod];
    setMethods(updatedMethods);
    setNewMethod("");
  };

  const handleAddIngredient = () => {
    if (newIngredient.trim() === "") return;
    const updatedIngredients = [...ingredients, newIngredient];
    setIngredients(updatedIngredients);
    setNewIngredient("");
  };

  return (
    <Modal
      title={isUpdating ? "Update Recipe" : "Add Recipe"}
      visible={isModalVisible}
      onCancel={handleModalCancel}
      keyboard={false}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <div className="p-4">
        <Form form={form} layout="vertical" 
         onFinish={() => {
            if (isUpdating) {
              handleSaveEdit({
                  name: name,
                  ingredients: ingredients,
                  methods: methods,
                  image: image,
                  description: description,
                  newMethod: newMethod,
                  newIngredient: newIngredient,
                  meta_description: meta_description,
                  meta_title: meta_title,
                  recipelink: recipelink
              });
            } else {
              handleFormSubmit();
            }
          }}
          >
          <section className=" md:space-x-4 w-full">
            <div className=" p-2">
              <TextInput
                title="Recipe Name"
                placeholder="Enter Recipe Name"
                inputValue={name}
                setInputValue={setName}
              />
            </div>
          </section>

          <TextAreaInput
            title="Description"
            placeholder="Enter Description"
            inputValue={description}
            setInputValue={setDescription}
          />

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-[75%] p-2">
              <TextInput
                title="Methods"
                name="newMethod"
                inputValue={newMethod}
                setInputValue={setNewMethod}
                placeholder="Enter Method"
               
              />
            </div>
            <div className="w-[25%] p-2 mt-[35px]">
              <button
                type="button"
                className="w-[120px] bg-teal-500 h-[40px] text-white px-2 py-[7px] rounded-md 
              flex items-center cursor-pointer"
                onClick={handleAddMethod}>
                <BsPlusCircle size={20} className="mr-1" />
                Add
              </button>
            </div>
          </section>

          <section className="flex flex-col md:space-y-4 mt-[15px]">
            {methods.length > 0 && (
              <div
                className="border p-2 bg-white rounded"
                style={{ maxHeight: "70px", overflowY: "auto" }}>
                <ul className="max-w-md divide-y divide-gray-200 dark:divide-gray-700 flex flex-wrap">
                  {methods.map((method, index) => (
                    <li
                      key={index}
                      className="w-full sm:w-1/2 border p-1 flex justify-between items-center space-x-4"
                      style={{ marginBottom: "1px" }}>
                      <p className="text-xs font-medium text-gray-900 truncate dark:text-white">
                        {method}
                      </p>

                      <div className="text-red-500 cursor-pointer ml-auto">
                        <FaTimesCircle
                          size={19}
                          onClick={() => handleRemoveMethod(index)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <section className="flex flex-col md:flex-row md:space-x-4 w-full">
              <div className="w-[75%] p-2">
                <TextInput
                  title="Ingredients"
                  name="newIngredient"
                  inputValue={newIngredient}
                  setInputValue={setNewIngredient}
                  placeholder="Enter Ingredient"
                 
                />
              </div>
              <div className="w-[25%] p-2 mt-[35px]">
                <button
                  type="button"
                  className="w-[120px] bg-teal-500 h-[40px] text-white px-2 py-[7px] rounded-md 
              flex items-center cursor-pointer"
                  onClick={handleAddIngredient}>
                  <BsPlusCircle size={20} className="mr-1" />
                  Add
                </button>
              </div>
            </section>

            {ingredients.length > 0 && (
              <div
                className="border p-2 bg-white rounded mt-2"
                style={{ maxHeight: "70px", overflowY: "auto" }}>
                <ul className="max-w-md divide-y divide-gray-200 dark:divide-gray-700 flex flex-wrap">
                  {ingredients.map((ingredient, index) => (
                    <li
                      key={index}
                      className="w-full sm:w-1/2 border p-1 flex justify-between items-center space-x-4"
                      style={{ marginBottom: "1px" }}>
                      <p className="text-xs font-medium text-gray-900 truncate dark:text-white">
                        {ingredient}
                      </p>

                      <div className="text-red-500 cursor-pointer ml-auto">
                        <FaTimesCircle
                          size={19}
                          onClick={() => handleRemoveIngredient(index)}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </section>

          <div className="w-full p-2">
            <label htmlFor="image-upload" className="block text-gray-700 mb-3">
              Image
            </label>
            <input
              id="image-upload"
              type="file"
              accept="image/*"
              onChange={handleFileChangeImage}
            />
            {image && (
              <div className="p-4 w-full">
                <img
                  src={image}
                  alt="Recipe"
                  style={{ width: "auto", maxHeight: "100px" }}
                />
              </div>
            )}
          </div>

    
          <SelectOption
            title="Flavours"
            value={productId}
            setValue={setProductId}
            placeholder="Select Flavours"
            options={products.map((product) => ({
              value: product.id.toString(),
              label: product.name,
            }))}
          
            name="productId"
          />

          <section className="flex flex-col md:flex-row md:space-x-4 w-full">
            <div className="w-1/2 p-2">
              <TextInput
                title="Meta Title"
                placeholder="Enter Meta Title"
                inputValue={meta_title}
                setInputValue={setMetaTitle}
              />
            </div>
            <div className="w-1/2 p-2">
              <TextInput
                title="Recipe URL"
                placeholder="Enter Recipe URL"
                inputValue={recipelink}
                setInputValue={setRecipeLink}
              />
            </div>
          </section>

          <TextAreaInput
            title="Meta Description"
            placeholder="Enter Meta Description"
            inputValue={meta_description}
            setInputValue={setMetaDescription}
          />

          {isUpdating ? (
            <Button
              htmlType="submit"
              className="bg-teal-800 w-full mt-4 text-white font-semibold py-2 px-4 border border-gray-400 rounded shadow"
             
              loading={loading}>
              {loading ? "Updating..." : "Update Recipe"}
            </Button>
          ) : (
            <Button
              htmlType="submit"
              className="bg-teal-800 w-full mt-4 text-white font-semibold py-2 px-4 border border-gray-400 rounded shadow"
              loading={loading}>
              {loading ? "Adding..." : "Add Recipe"}
            </Button>
          )}
        </Form>
      </div>
    </Modal>
  );
};

export default RecipeModal;
